module.exports = __webpack_public_path__ + "media/dashboard/assets/images/controller-record-aebcfaa3f608ba9d856acc9ca320b0f9.svg";